import React, { Component } from 'react';

import './AnimatedVideo.scss';

import {
    Dispatcher,
    Actions,
    Events
} from '../flux';

class AnimatedVideo extends Component {

	constructor() {
        super();

        this.state = {}
	}

    componentWillUnount() {
        // window.removeEventListener('wheel', this.imageReveal);
    }

	render() {

        const sources = []; 

        if (this.props.mp4) {
            sources.push(
                <source src={ this.props.mp4 } type='video/mp4' />
            );
        }

        if (this.props.ogg) {
            sources.push(
                <source src={ this.props.ogg } type='video/ogg' />
            );
        }

        return (
            <video className="animated_video" autoPlay loop>
                { sources }
                Your browser does not support the video tag.
            </video>
    	);
	}
}

export { AnimatedVideo };